var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("page.top")))]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("h2", { staticClass: "title is-4" }, [
          _vm._v(_vm._s(_vm.$t("page.Services"))),
        ]),
        _vm._v(" "),
        _c("service-links", { attrs: { services: _vm.services } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }